export enum ROLE {
    Expert = 'Expert',
    NewUser = 'NewUser',
    Secretary = 'Secretary',
    SuperUser = 'SuperUser'
}
